<template>
<label class="v-toggle" :class="{'v-toggle--checked': checked}">
  <input type="checkbox" v-model="checked" :name="name">
  <span class="v-toggle_handle"></span>
</label>
</template>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    }
  }
}
</script>

<style>
:root {
  --vui-green: #42b983;
  --ios-green: #4cd964;
  --ios-blue: #027AFB;
  --android-green: #009A57;
  --menu-button-color: #aaa;
  --range-slider-color: #027AFB;
}

/** Toggle */
.ios .v-toggle {
  width: 51px;
}
.ios .v-toggle--checked.v-toggle {
  background: var(--ios-green);
  border-color: var(--ios-green);
}
.ios .v-toggle .v-toggle_handle {
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.35), 0 1px 1px rgba(0, 0, 0, 0.15);
}
.ios .v-toggle--checked .v-toggle_handle {
  transform: translate3d(20px, 0, 0);
}
.ios .v-toggle:before {
  content: '';
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background: #e6e6e6;
  transition: opacity 0.3s;
}
.ios .v-toggle--checked:before {
  opacity: 0;
}
.ios .v-toggle:after {
  content: '';
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 20px;
  transform: scale3d(1, 1, 1);
  transition: transform 0.3s;
}
.ios .v-toggle--checked:after {
  transform: scale3d(0, 0, 0);
  opacity: 1;
}


/** Range Slider */
.ios .v-range-slider input::-webkit-slider-runnable-track {
  height: 1px;
}
.ios .v-range-slider input::-webkit-slider-thumb:before {
  background: var(--ios-blue);
  height: 1px;
}
.ios .v-range-slider input::-webkit-slider-thumb {
  box-shadow: 0 0 1px rgba(0,0,0,.3), 0 3px 5px rgba(0,0,0,0.2);
}

/** Radio Group */
.ios .v-radio input:before {
  opacity: 0;
}
.ios .v-radio li {
  border-bottom: 1px solid #ddd;
  margin-left: 2em;
  padding: 0.6em 0 0.4em;
}
.ios .v-radio li:last-of-type {
  border-bottom: 0;
}
.ios .v-radio li input {
  margin-left: -2.2em;
}
.ios .v-radio input:checked:before {
  opacity: 1;
  border-color: var(--ios-blue);
}

label.v-toggle {
  position: relative;
  display: inline-block;
  height: 31px;
  width: 68px;
  border-radius: 20px;
  box-sizing: border-box;
  background: #e6e6e6;
  border: solid 2px #e6e6e6;
  cursor: pointer;
  vertical-align: middle;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
}
label.v-toggle input {
  display: none;
}
label.v-toggle--checked.v-toggle {
  background: var(--vui-green);
  border-color: var(--vui-green);
}
.v-toggle .v-toggle_handle {
  position: absolute;
  left: 0;
  top: 0;
  display: inline-block;
  background: white;
  border-radius: 100%;
  width: 27px;
  height: 27px;
  z-index: 99;
  transition: transform 0.3s;
}
.v-toggle--checked .v-toggle_handle {
  transform: translate3d(37px, 0, 0);
}
.v-toggle::before,
.v-toggle::after {
  position: absolute;
  top: 0;
  font-size: 12px;
  line-height: 28px;
}
.v-toggle::before {
  left: 5px;
  content: 'ON';
  color: white;
  opacity: 0;
}
.v-toggle::after {
  right: 5px;
  content: 'OFF';
  color: #aaa;
}
.v-toggle--checked.v-toggle::before {
  opacity: 1;
}
.v-toggle--checked.v-toggle::after {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// Toggle.vue?c95700f6